import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizSpin, WizCard, WizForm, WizRow, WizCol, WizButton } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool
import { WizBraftEditorPlus } from '@/containers/common'

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/preAuditProcess/sendNotification') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('preAuditSendNotification', record)
        } else {
            record = Session.get('preAuditSendNotification') || {}
        }
    }
    return record
}

const validator = (rule, value, callback) => {
    if (value && value !== '<p></p>') {
        callback()
        return
    }
    callback('请输入预审核通知')
}

class SendNotification extends WizContainer {

    componentName = 'SendNotification'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record
        }
    }

    _componentDidMount() {
        this._detail()
    }

    _detail = () => {
        const { recordId, state } = this.state.record
        if (state !== 1) {
            this.doAction({
                path: 'counselingProcess/preAuditOrCheckDetail',
                payload: {
                    key: 'preAuditNoticeDetail@' + recordId,
                    apiParams: {
                        id: recordId
                    }
                }
            })
        }
    }

    _onSub = () => {
        const { processContentId } = this.state.record
        this.refs.form.validateFields((err, values) => {
            if (!err) {
                let { content } = values
                let params = {
                    content,
                    processId: processContentId,
                    type: 0
                }
                this.doAction({
                    path: 'counselingProcess/sendPreAuditOrCheck',
                    payload: {
                        key: 'sendPreAuditNotice@' + processContentId,
                        apiParams: params
                    }
                })
            }
        })
    }

    propsAndStateOnChange = {
        save: this._saveOnChange.bind(this)
    }

    _saveOnChange(nextProps, nextState) {
        if (nextProps.save.code === 1) {
            wizNotice.success('操作成功')
            this.jumpPage('goBack')
        } else {
            wizNotice.error(nextProps.save.msg)
        }
    }

    _renderFooter = () => {
        return (
            <WizRow className='form-btns row-item'>
                <WizCol span={24}>
                    <WizButton type='primary' onClick={() => this._onSub()}>{'确认'}</WizButton>
                </WizCol>
            </WizRow>
        )
    }

    render() {
        let { detail, counselingProcessLoading } = this.props
        let { data } = detail
        let columns = [{
            title: '预审核通知',
            name: 'content',
            dataIndex: 'content',
            formItem: {
                type: 'custom',
                render: (r, f) => {
                    const { getFieldDecorator } = f
                    return getFieldDecorator('content', {
                        initialValue: r ? r.content : undefined,
                        rules: [{ required: true, validator }]
                    })(<WizBraftEditorPlus links={[0, 1, 2, 3]} />)
                }
            },
        }]
        let formProps = {
            ref: 'form',
            columns,
            record: data,
            preview: null,
            footer: this._renderFooter(),
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            },
            style: { maxWidth: '100%', width: '100%' }
        }
        return (
            <WizSpin spinning={counselingProcessLoading} >
                <WizCard title='下发预审核通知'>
                    <WizForm key={data ? data.id : 'send'} {...formProps} />
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { processContentId, recordId } = findParamRecord(ownProps.history)
    const detail = modelUtils.getModelEntity(counselingProcess, 'preAuditNoticeDetail@' + recordId)
    const save = modelUtils.getModelEntity(counselingProcess, 'sendPreAuditNotice@' + processContentId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        detail,
        save,
        ...loading
    }
}

export default connect(mapStateToProps)(SendNotification)


